



















import Vue from 'vue'

import { Widget } from '../base'
import ActivitiyItem from './ActivityItem.vue'

export default Vue.extend({
  props: {
    widget: {
      type: Object as () => Widget,
      required: true
    }
  },
  components: {
    ActivitiyItem
  },
  data() {
    return {
      demoContent: [
        {
          author: "Lubosek Hnilo ",
          text:
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna.",
          date: "10.27 Uhr"
        },
        {
          author: "Leonardo Oliveira",
          text:
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna.",
          date: "10.24 Uhr"
        }
      ]
    }
  }
})
